
import MenuCreateCombo from "../../../components/menu/menu-create-combo.vue";
import { mapState } from "vuex";
export default {
  components: { MenuCreateCombo },
  data() {
    return {
      combo: {}
    };
  },
  computed: {
    ...mapState("menu", ["combosList"])
  },
  beforeMount() {
    this.combo = this.combosList.find(
      (el) => el.id == this.$nuxt.$route.params.id
    );
  }
};
